
import React from 'react';
import { Settings, Download, LayoutTemplate, HelpCircle } from 'lucide-react';
import { ImageResolution, AspectRatio, AppSettings, WorkItem } from '../types';
import { downloadAllImages } from '../utils/helpers';

interface HeaderProps {
  settings: AppSettings;
  setIsSettingsOpen: (v: boolean) => void;
  batchSize: number;
  setBatchSize: (v: 1 | 4 | 9) => void;
  resolution: ImageResolution;
  setResolution: (v: ImageResolution) => void;
  aspectRatio: AspectRatio;
  setAspectRatio: (v: AspectRatio) => void;
  workItems: WorkItem[];
  onOpenTutorial: () => void;
}

export const Header: React.FC<HeaderProps> = ({ 
    settings, setIsSettingsOpen, batchSize, setBatchSize, 
    resolution, setResolution, aspectRatio, setAspectRatio, workItems,
    onOpenTutorial
}) => {
  return (
    <header className="h-16 bg-slate-900 border-b border-slate-700 flex items-center justify-between px-6 shadow-md z-10 shrink-0">
      <div className="flex items-center gap-3">
        <div className="bg-indigo-600 p-2 rounded-lg shadow-lg shadow-indigo-500/20">
           <LayoutTemplate className="w-5 h-5 text-white" />
        </div>
        <h1 className="text-xl font-bold text-white tracking-tight mr-1">GenStudio <span className="text-indigo-400 font-light">专业版</span></h1>
        
        <button 
          onClick={onOpenTutorial}
          className="text-slate-500 hover:text-indigo-400 transition-colors p-1 rounded-full hover:bg-slate-800" 
          title="使用教程"
        >
          <HelpCircle size={18} />
        </button>
      </div>

      <div className="flex items-center gap-4">
        <button onClick={() => setIsSettingsOpen(true)} className="p-2 rounded-lg bg-slate-800 text-slate-400 hover:text-white hover:bg-slate-700 transition-colors">
            <Settings size={20} />
        </button>
        <div className="h-6 w-px bg-slate-700 mx-2"></div>

        <div className="flex items-center bg-slate-800 rounded-md p-1 border border-slate-700">
            <span className="text-xs font-semibold px-2 text-slate-400">数量</span>
            {[1, 4, 9].map((n) => (
                <button key={n} onClick={() => setBatchSize(n as 1|4|9)} className={`w-8 py-1 rounded text-xs font-bold transition-all ${batchSize === n ? 'bg-indigo-600 text-white shadow' : 'text-slate-400 hover:text-slate-200'}`}>
                    {n}
                </button>
            ))}
        </div>

        <div className="flex items-center bg-slate-800 rounded-md p-1 border border-slate-700">
            <span className="text-xs font-semibold px-2 text-slate-400">分辨率</span>
            {(['1K', '2K', '4K'] as ImageResolution[]).map(r => (
                <button key={r} onClick={() => setResolution(r)} className={`px-3 py-1 rounded text-xs font-medium transition-all ${resolution === r ? 'bg-indigo-600 text-white shadow' : 'text-slate-400 hover:text-slate-200'}`}>
                    {r}
                </button>
            ))}
        </div>

        <div className="flex items-center bg-slate-800 rounded-md p-1 border border-slate-700">
            <span className="text-xs font-semibold px-2 text-slate-400">比例</span>
            <select value={aspectRatio} onChange={(e) => setAspectRatio(e.target.value as AspectRatio)} className="bg-transparent text-xs font-medium text-slate-200 outline-none cursor-pointer max-w-[60px]">
                {['1:1', '16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '21:9', 'auto'].map(r => <option key={r} value={r}>{r}</option>)}
            </select>
        </div>

        <button onClick={() => downloadAllImages(workItems)} className="flex items-center gap-2 px-4 py-2 bg-slate-800 hover:bg-slate-700 border border-slate-600 text-slate-200 rounded-lg text-sm font-medium transition-colors">
          <Download size={16} /> 导出
        </button>
      </div>
    </header>
  );
};
